if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          mainSwiper: null,
          thumbSwiper: null
        };

        // Wait for Alpine.js to initialize the Swiper instances
        this.addEventListener('swiper:ready', (event) => {
          this.elements.mainSwiper = event.detail.mainSwiper;
          this.elements.thumbSwiper = event.detail.thumbSwiper;
        });
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        if (!this.elements.mainSwiper) return;
        // Find the slide index with matching mediaId
        const slideIndex = Array.from(
          this.querySelectorAll('.product-main-slider .swiper-slide')
        ).findIndex(slide => slide.dataset.mediaId === mediaId);

        if (slideIndex !== -1) {
          // Move to the matching slide
          this.elements.mainSwiper.slideTo(slideIndex);
          
          if (this.elements.thumbSwiper) {
            this.elements.thumbSwiper.slideTo(slideIndex);
          }

          // Handle media playback
          const activeSlide = this.elements.mainSwiper.slides[slideIndex];
          this.playActiveMedia(activeSlide);
        }

        // Handle prepend case (usually for variant selection)
        if (prepend && slideIndex !== 0) {
          // Wait for next tick to ensure Swiper is ready
          setTimeout(() => {
            const slides = this.elements.mainSwiper.slides;
            const activeSlide = slides[slideIndex];
            
            // Move slide to start
            this.elements.mainSwiper.removeSlide(slideIndex);
            this.elements.mainSwiper.prependSlide(activeSlide);
            this.elements.mainSwiper.slideTo(0);

            // Update thumbnails if they exist
            if (this.elements.thumbSwiper) {
              const thumbSlides = this.elements.thumbSwiper.slides;
              const activeThumb = thumbSlides[slideIndex];
              this.elements.thumbSwiper.removeSlide(slideIndex);
              this.elements.thumbSwiper.prependSlide(activeThumb);
              this.elements.thumbSwiper.slideTo(0);
            }
          }, 0);
        }

        this.preventStickyHeader();
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) => element.removeAttribute("aria-current"));
        thumbnail.querySelector("button").setAttribute("aria-current", true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({
          left: thumbnail.offsetLeft,
        });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector(
          ".product__modal-opener--image img"
        );
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute("aria-hidden", false);
          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position
            );
          setTimeout(() => {
            this.elements.liveRegion.setAttribute("aria-hidden", true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia?.();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent?.(false);
      }

      preventStickyHeader() {
        this.stickyHeader = 
          this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute("role", "presentation");
        this.elements.viewer.sliderItems.forEach((slide) =>
          slide.setAttribute("role", "presentation")
        );
      }
    }
  );
}
